module.exports = __webpack_public_path__ + "static/media/Balcony.8cdc0d88.JPG";